import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-editor-autosave-indicator',
  templateUrl: './editor-autosave-indicator.component.html',
  styleUrls: ['./editor-autosave-indicator.component.scss'],
  standalone: true,
  imports: [MatIconModule, TranslateModule],
  host: {
    class: 'autosave-indicator',
    '[class.autosave-indicator--visible]': 'isVisible',
    '[class.autosave-indicator--saving]': 'isSaving',
    '[class.autosave-indicator--saved]': 'isSaved',
    '[class.autosave-indicator--failed]': 'isSaveFailed',
    'aria-live': 'polite',
  },
})
export class EditorAutosaveIndicatorComponent {
  @Input() isSaving = false;
  @Input() isSaved = false;
  @Input() isSaveFailed = false;

  get isVisible(): boolean {
    return this.isSaving || this.isSaved || this.isSaveFailed;
  }
}
